/**
 * @generated SignedSource<<a2270dac53ec08aad94c20c772338924>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ifCanAccessQuery$variables = Record<PropertyKey, never>;
export type ifCanAccessQuery$data = {
  readonly user: {
    readonly email: string;
  };
};
export type ifCanAccessQuery = {
  response: ifCanAccessQuery$data;
  variables: ifCanAccessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ifCanAccessQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserInfo",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ifCanAccessQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserInfo",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f71df3503b6ba66d6eeae369714ab5da",
    "id": null,
    "metadata": {},
    "name": "ifCanAccessQuery",
    "operationKind": "query",
    "text": "query ifCanAccessQuery {\n  user {\n    email\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "79d699b2d0d34f0d6c5abcc13df3e432";

export default node;
